import React from 'react';
import './Header.css';

const Header = ({ rightContent }) => {
  const currentUser = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('currentUser') || 'null');
    } catch {
      return null;
    }
  }, []);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <div className="logo-container">
            <img 
              src="/images/genpactLogoWhite.png" 
              alt="Genpact Logo" 
              className="genpact-logo" 
              onError={(e) => { e.target.style.display = 'none'; }} // Hides broken icon if path is wrong
            />
          </div>
          <h1 className="header-title">Genpact Adjuster Assist</h1>
        </div>
        <div className="header-right">
          {rightContent}
          {currentUser?.name && (
            <div className="header-user" title={currentUser.name}>
              <i className="fas fa-user" aria-hidden="true"></i>
              <span>{currentUser.name}</span>
            </div>
          )}
        </div>
        
        {/* Navigation and Logout remain commented out as per your previous setup */}
      </div>
    </header>
  );
};

export default Header;

